/* BRANDSETS – podstrony (v30, 03.10.2026), wygląd: assets/bs-pages.css
   1) Dokumenty /policies/… (Regulamin, Polityka prywatności, Zasady zwrotów, Kontakt):
      - usuwa puste akapity i puste tabele-ozdobniki wklejone z Worda/PDF,
      - porządkuje nagłówki (twarde spacje z wyśrodkowania),
      - „SPIS TREŚCI” zamienia na klikalny spis (link do każdego rozdziału),
      - tytuły rozdziałów pisane WERSALIKAMI pokazuje zwykłymi literami (w spisie i w treści),
      - w Kontakcie e-mail i telefon stają się klikalne.
   2) FAQ: pod opisem dodaje pigułki z nazwami grup pytań (skok do grupy).
   3) Tabele z treścią dostają klasę bs-table (karta z szarym nagłówkiem).
   4) O nas: akapity z samym pogrubieniem dostają klasę bs-sub (śródtytuły). */
(function () {
  var NBSP = String.fromCharCode(160);
  function clean(t) {
    return String(t || '').split(NBSP).join(' ').replace(/\s+/g, ' ').trim();
  }
  function key(t) {
    return clean(t).replace(/[:.]+$/, '').toUpperCase();
  }
  /* „POSTANOWIENIA OGÓLNE” -> „Postanowienia ogólne” (tylko tekst pisany w całości wersalikami) */
  function sentence(t) {
    if (t.length < 4 || t !== t.toUpperCase() || t === t.toLowerCase()) return t;
    var s = t.toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function tidyTables(root) {
    each(root.querySelectorAll('table'), function (table) {
      if (!clean(table.textContent) && !table.querySelector('img')) {
        table.remove();
      } else {
        table.classList.add('bs-table');
        each(table.querySelectorAll('td, th'), function (cell) {
          var bg = cell.getAttribute('bgcolor') || cell.style.backgroundColor;
          if (bg && !/^(transparent|white|#fff(fff)?|rgba?\(255,\s*255,\s*255(,\s*1)?\))$/i.test(bg.replace(/\s+/g, ' '))) {
            cell.classList.add('bs-th');
          }
        });
      }
    });
  }

  function policies() {
    var root = document.querySelector('.shopify-policy__body');
    if (!root) return;

    tidyTables(root);

    /* puste akapity i nagłówki (same <br> albo twarde spacje) */
    each(root.querySelectorAll('p, h1, h2, h3, h4, h5, h6'), function (el) {
      if (!clean(el.textContent) && !el.querySelector('img, iframe, input, a')) el.remove();
    });

    /* nagłówki: bez twardych spacji i łamań z wyśrodkowania */
    each(root.querySelectorAll('h1, h2, h3, h4'), function (h) {
      if (!h.querySelector('a, img')) h.textContent = clean(h.textContent);
    });

    /* klikalny spis treści */
    var label = null;
    each(root.querySelectorAll('p, h3, h4, h5, div'), function (el) {
      if (!label && /^SPIS TREŚCI$/.test(key(el.textContent)) && el.children.length < 3) label = el;
    });
    if (label) {
      var list = label.nextElementSibling;
      while (list && list.tagName !== 'OL' && list.tagName !== 'UL') list = list.nextElementSibling;
      if (list) {
        var heads = Array.prototype.filter.call(root.querySelectorAll('h2, h3'), function (h) {
          return !list.contains(h);
        });
        var minor = Array.prototype.filter.call(root.querySelectorAll('h4'), function (h) {
          return !list.contains(h);
        });
        var n = 0;
        each(list.children, function (li) {
          var t = key(li.textContent);
          var h = null;
          for (var i = 0; i < heads.length; i++) {
            if (key(heads[i].textContent) === t) { h = heads[i]; break; }
          }
          for (var j = 0; !h && j < minor.length; j++) {
            if (key(minor[j].textContent) === t) h = minor[j];
          }
          if (!h) {
            if (!li.children.length) li.textContent = sentence(clean(li.textContent));
            return;
          }
          n += 1;
          if (!h.id) h.id = 'bs-rozdzial-' + n;
          /* tytuły rozdziałów zwykłymi literami (w spisie i w treści) */
          if (!h.children.length) h.textContent = sentence(clean(h.textContent));
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = sentence(clean(li.textContent));
          li.textContent = '';
          li.appendChild(a);
        });
        var nav = document.createElement('nav');
        nav.className = 'bs-toc';
        nav.setAttribute('aria-label', 'Spis treści');
        label.parentNode.insertBefore(nav, label);
        var title = document.createElement('p');
        title.className = 'bs-toc__title';
        title.textContent = 'Spis treści';
        nav.appendChild(title);
        nav.appendChild(list);
        list.classList.add('bs-toc__list');
        label.remove();
      }
    }

    /* Kontakt: klikalny e-mail i telefon */
    if (document.body.classList.contains('bs-policy--contact-information')) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      var re = /([\w.+-]+@[\w-]+(?:\.[\w-]+)+)|(\+48[\d\s]{9,13}\d)/g;
      nodes.forEach(function (node) {
        if (node.parentNode.closest('a')) return;
        var text = node.nodeValue;
        if (!re.test(text)) return;
        re.lastIndex = 0;
        var frag = document.createDocumentFragment();
        var last = 0;
        text.replace(re, function (m, mail, tel, idx) {
          frag.appendChild(document.createTextNode(text.slice(last, idx)));
          var a = document.createElement('a');
          a.href = mail ? 'mailto:' + mail : 'tel:' + tel.replace(/\s/g, '');
          a.textContent = m;
          frag.appendChild(a);
          last = idx + m.length;
          return m;
        });
        frag.appendChild(document.createTextNode(text.slice(last)));
        node.parentNode.replaceChild(frag, node);
      });
    }
  }

  function pages() {
    each(document.querySelectorAll('.bs-page .rte, .template--about-us .seo-content .rte'), tidyTables);
    /* O nas: akapit złożony z samego pogrubienia = śródtytuł */
    each(document.querySelectorAll('.template--about-us .seo-content .rte p'), function (p) {
      var b = p.querySelector('strong, b');
      if (b && clean(b.textContent) && clean(b.textContent) === clean(p.textContent)) p.classList.add('bs-sub');
    });
  }

  function faq() {
    if (!document.body.classList.contains('template--faq')) return;
    var heads = document.querySelectorAll('.accordions .section__heading');
    if (heads.length < 2) return;
    var nav = document.createElement('nav');
    nav.className = 'bs-faq-nav';
    nav.setAttribute('aria-label', 'Grupy pytań');
    each(heads, function (h, i) {
      if (!h.id) h.id = 'faq-' + (i + 1);
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = clean(h.textContent);
      nav.appendChild(a);
    });
    var spot = document.querySelector('.template--faq .section-page-banner__content');
    if (spot) {
      spot.appendChild(nav);
    } else {
      var first = document.querySelector('.accordions');
      if (first) first.parentNode.insertBefore(nav, first);
    }
  }

  function init() {
    policies();
    pages();
    faq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
